export enum OfficeTnCTypeEnum {
  OFFICE_TNC_PERM = 'office_tnc_perm',
  OFFICE_TNC = 'office_tnc',
}
